import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl } from "../Components/baseUrl";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Menu from "../Components/Menu";
import NotifModal from "../Components/NotifModal";

const Notifications = () => {
    const navigate = useNavigate();
    let token;
    if (typeof window !== "undefined") {
        token = localStorage.getItem("token");
    }
    useEffect(() => { 
        document.title = "پایا | اعلان ها";
        token == null && navigate("/login", { replace: true });
    }, []);
    const [notifList, setNotifList] = useState([]);
    const getNotifs = (e) => {
        let config = {
            url: `${baseUrl}/notification`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                res && res.data && res.data.data && setNotifList(res.data?.data?.notifications);
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    useEffect(() => {
        getNotifs();
    }, []);
    const [showNotif, setShowNotif] = useState(false);
    const [notifItem, setNotifItem] = useState([]);
    const showNotifHandler = (item) => {
        setShowNotif(true);
        let config = {
            url: `${baseUrl}/notification-read/${item.id}`,
            method: "POST",
        };
        axios(config)
            .then((res) => {
                res && res.data && res.data.data && setNotifList(res.data.data);
                getNotifs();
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    return (
        <div>
            <div className="container">
                {showNotif && (
                    <div
                        onClick={() => {
                            setShowNotif(false);
                        }}
                        id="bg_gray"
                        className="bg-gray"
                    ></div>
                )}
                {showNotif && <NotifModal item={notifItem} />}
                <div className="orders-main notif-main">
                    {notifList &&
                        notifList.length !== 0 &&
                        notifList.map((item) => {
                            return (
                                <div
                                    className="orders-card"
                                    onClick={() => {
                                        setNotifItem(item);
                                        showNotifHandler(item);
                                    }}
                                >
                                    {/* <img
                                        src="./assets/images/cart-img.png"
                                        alt=""
                                    /> */}
                                    <div>
                                        <span className="name">
                                            {item.title}
                                        </span>
                                        <span className="fullname">
                                            {item.Content}
                                        </span>
                                        <div className="dates mt-17">
                                            {item.is_read &&
                                            item.is_read !== false ? (
                                                <svg
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 20 20"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <rect
                                                        width="20"
                                                        height="20"
                                                        rx="10"
                                                        fill="#D9D9D9"
                                                    />
                                                </svg>
                                            ) : (
                                                <svg
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 20 20"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <rect
                                                        width="20"
                                                        height="20"
                                                        rx="10"
                                                        fill="#61FF00"
                                                    />
                                                </svg>
                                            )}

                                            <span>{item.Created_at}</span>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    <Menu active="setting" />
                </div>
            </div>
        </div>
    );
};

export default Notifications;
